<template>
  <div>
    <div class="sidenav-backdrop" @click="CloseSideNav()">
    </div>
    <div class="sidenav-wrapper" id="app-sidenav">
      <div class="mobile-close-trigger" @click="CloseSideNav()">
        <i class="las la-long-arrow-alt-left"></i>
      </div>
      <div class="nav-wrapper">
        <div class="user-info-wrapper">
          <div class="user-avatar" :style="{ backgroundImage: 'url(' + media.profile_1 + ')' }"></div>
          <div class="user-name">
            <div class="name-text">
              AHMED ZOBYER
            </div>
          </div>
        </div>
        <div class="nav-menu-wrapper">
          <ul class="nav-menu">
            <li class="each-menu">
              <router-link to="/" class="menu-link">
                <i class="las la-home"></i>
                HOME
              </router-link>
            </li>
            <li class="each-menu">
              <router-link to="resume" class="menu-link">
                <i class="las la-user-graduate"></i>
                RESUME
              </router-link>
            </li>
            <li class="each-menu">
              <router-link to="portfolio" class="menu-link">
                <i class="las la-project-diagram"></i>
                PORTFOLIO
              </router-link>
            </li>
            <li class="each-menu">
              <router-link to="services" class="menu-link">
                <i class="lab la-blogger"></i>
                SERVICES
              </router-link>
            </li>
            <li class="each-menu">
              <router-link to="contacts" class="menu-link">
                <i class="las la-voicemail"></i>
                CONTACT
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="nav-bottom-wrapper">
        <ul class="social-btn-wrapper">
          <li class="each-btn">
            <a href="https://www.linkedin.com/in/zobayer-me/" target="_blank">
              <i class="lab la-linkedin"></i>
            </a>
          </li>
          <li class="each-btn">
            <a href="skype:shudhui.ami?chat" target="_blank">
              <i class="lab la-skype"></i>
            </a>
          </li>
          <li class="each-btn">
            <a href="https://www.npmjs.com/~shudhuiami" target="_blank">
              <i class="lab la-npm"></i>
            </a>
          </li>
          <li class="each-btn">
            <a href="https://github.com/shudhuiami" target="_blank">
              <i class="lab la-github"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      name: '',
      media: {
        profile_1: core.APP_PATH + '/avatar/profile_1.jpg',
        profile_2: core.APP_PATH + '/avatar/profile_2.jpg',
      },
    }
  },
  watch: {

  },
  methods: {
    CloseSideNav() {
      $('#app-sidenav').removeClass('_active')
      $('.sidenav-backdrop').removeClass('_active')
    }
  },
  created() {

  },
  mounted() {

  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/global/side_nav.vue